/*
 * inselvolt Kompatibilitätsberater — Einstiege messen: Kategorie-Streifen,
 * Startseite, Box und Textlink in Artikeln und Themenseiten, Hauptmenü, Footer.
 *
 * Wozu: Das Messkonzept (Arbeitsliste Abschnitt 5) fragt nach der Startquote
 * je Seitentyp — welche Fläche den Berater tatsächlich startet. Beraterseite
 * (Kontext `berater`) und Produktseiten-Teaser (`pdp`) melden sich selbst. Die
 * übrigen Einstiege sind bloße Verweise ohne eigenes Skript; ohne diese Datei
 * wüsste die Auswertung nicht, dass es sie gibt.
 *
 * Gemeldet wird wie überall: ein Eintrag im dataLayer (Form wie emit() in
 * berater-ui.js) und dieselbe Brücke zu Clarity (app/clarity.js, Kontext
 * `einstieg`). Keine zweite Ereignisdefinition.
 *
 *   gesehen   Eine Fläche steht zur Hälfte im Bild — einmal je Fläche und
 *             Seitenaufruf. Bewusst Sicht, nicht Anwesenheit (anders als der
 *             Teaser auf der Produktseite): Eine Box am Ende eines langen
 *             Artikels erreicht die Mehrheit nie. Gegen die bloße Anwesenheit
 *             gerechnet, läge ihre Quote zu tief, und der Vergleich mit dem
 *             Streifen oben auf der Kategorie wäre schief.
 *   geklickt  Ein Verweis auf die Beraterseite wird angeklickt — jeder Klick,
 *             auch mit Strg oder Mitteltaste in einen neuen Tab.
 *
 * Fläche = Seitentyp und Form: `kategorie` (Streifen), `startseite`,
 * `artikel_box`, `artikel_link`, `seite_box`, `seite_link`, `menue`, `footer`;
 * ein Verweis an anderer Stelle heißt `<seitentyp>_link`. „gesehen" melden nur
 * Flächen, die als solche gesetzt sind (Streifen, Box, Textlink mit der Klasse
 * iv-berater-verweis). Menü und Footer stehen auf jeder Seite — ihre
 * Bezugsgröße sind die Sitzungen insgesamt, nicht eine Sichtung.
 *
 * Nicht gemeldet wird auf der Beraterseite selbst und innerhalb des
 * Produktseiten-Teasers (.iv-pdp): Beide messen sich bereits.
 *
 * Geladen von layout/theme.liquid auf jeder Seite (defer, am Ende von <body>).
 * Steht die Brücke nicht schon auf der Seite, lädt diese Datei sie nach — die
 * Adresse kommt aus data-messbruecke. Auf Produkt- und Beraterseite ist sie
 * bereits da; dort wird nichts doppelt geladen.
 */
(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) module.exports = { erzeuge: factory };
  if (root && root.document && !root.IV_EINSTIEG) {
    root.IV_EINSTIEG = factory(root, root.document, root.document.currentScript);
    root.IV_EINSTIEG.start();
  }
})(typeof window !== 'undefined' ? window : null, function (root, doc, skript) {
  'use strict';

  var BERATER_PFAD = '/pages/speicher-wechselrichter-kompatibilitaet';

  /* Shopifys request.page_type → Seitentyp im Flächennamen. Was hier fehlt,
   * heißt `sonstige` — erkennbar, statt still in einem falschen Topf. */
  var SEITENTYPEN = {
    article: 'artikel', page: 'seite', collection: 'kategorie', index: 'startseite',
    product: 'produkt', blog: 'blog', search: 'suche', cart: 'warenkorb',
    'list-collections': 'kategorien',
  };

  /* Ab der Hälfte im Bild gilt eine Fläche als gesehen. */
  var SICHT_ANTEIL = 0.5;

  /* Woran Menü und Footer zu erkennen sind: Dawn rendert das Hauptmenü in
   * <header>, die mobile Schublade in header-drawer/menu-drawer. */
  var MENUE = 'header, header-drawer, menu-drawer, .header-wrapper';
  var FOOTER = 'footer, .footer';

  /* Was gesehen werden kann: Streifen (auch der der Startseite), Box,
   * gekennzeichneter Textlink. Die Box trägt iv-berater-verweis ebenfalls — sie
   * kommt trotzdem nur einmal vor, querySelectorAll liefert jedes Element einmal. */
  var SICHTBAR = '.iv-streifen, .iv-inline, .iv-berater-verweis';

  var gemeldet = {};       // Fläche → schon als gesehen gemeldet (je Seitenaufruf)
  var warteschlange = [];  // Meldungen, bevor die Brücke geladen ist
  var brueckeLaedt = false;

  function attribut(name) {
    try { return skript && skript.getAttribute ? skript.getAttribute(name) : null; }
    catch (fehler) { return null; }
  }

  var typ = SEITENTYPEN[attribut('data-seitentyp')] || 'sonstige';

  function istBeraterseite() {
    var pfad = (root.location && root.location.pathname) || '';
    return pfad.indexOf(BERATER_PFAD) === 0;
  }

  /* Ein Verweis auf die Beraterseite — gleich ob relativ oder mit Domain, mit
   * oder ohne Anker. Es entscheidet der Pfad, nicht der Linktext. */
  function zumBerater(a) {
    if (!a || typeof a.pathname !== 'string') return false;
    return a.pathname.replace(/\/+$/, '') === BERATER_PFAD;
  }

  /* Die gestellte Frage steht im Anker: „#wr_finden&sp=…" → wr_finden. */
  function aufgabe(a) {
    var anker = String(a.hash || '').replace(/^#/, '').split('&')[0];
    return anker || null;
  }

  function flaeche(el) {
    if (!el || typeof el.closest !== 'function') return null;
    if (el.closest('.iv-pdp')) return null;
    if (el.closest('.iv-streifen--start')) return 'startseite';
    if (el.closest('.iv-streifen')) return 'kategorie';
    if (el.closest('.iv-inline')) return typ + '_box';
    if (el.closest(MENUE)) return 'menue';
    if (el.closest(FOOTER)) return 'footer';
    return typ + '_link';
  }

  // ------------------------------------------------------------------ Melden

  function bruecke() {
    var b = root.IV_CLARITY;
    return b && typeof b.melde === 'function' ? b : null;
  }

  function abarbeiten() {
    var b = bruecke();
    if (!b) return;
    var liste = warteschlange;
    warteschlange = [];
    for (var i = 0; i < liste.length; i++) b.melde('einstieg', liste[i][0], liste[i][1]);
  }

  function ladeBruecke() {
    if (brueckeLaedt || bruecke()) return;
    var adresse = attribut('data-messbruecke');
    if (!adresse || !doc || typeof doc.createElement !== 'function') return;
    brueckeLaedt = true;
    var s = doc.createElement('script');
    s.src = adresse;
    s.async = true;
    s.onload = abarbeiten;
    (doc.head || doc.documentElement).appendChild(s);
  }

  function melde(ivEvent, tags) {
    var b = bruecke();
    if (b) { b.melde('einstieg', ivEvent, tags); return; }
    warteschlange.push([ivEvent, tags]);
    ladeBruecke();
  }

  /*
   * dataLayer und Clarity aus EINER Stelle — wie emit() in berater-ui.js. In
   * Clarity steht die Fläche je Stufe in einem eigenen Tag (iv_flaeche_ +
   * Stufe); warum, steht bei KONTEXTE.einstieg in app/clarity.js.
   */
  function emit(ivEvent, wo, frage) {
    try {
      root.dataLayer = root.dataLayer || [];
      root.dataLayer.push({
        event: 'iv_berater', iv_event: ivEvent, iv_kontext: 'einstieg',
        iv_flaeche: wo, iv_seitentyp: typ, iv_aufgabe: frage || null,
      });
      var tags = {};
      tags['iv_flaeche_' + ivEvent] = wo;
      melde(ivEvent, tags);
    } catch (fehler) { /* Messung ist nie wichtiger als der Verweis */ }
  }

  // --------------------------------------------------------------- Gesehen

  function sichtMelden(el) {
    var wo = flaeche(el);
    if (!wo || gemeldet[wo]) return;
    gemeldet[wo] = true;
    emit('gesehen', wo);
  }

  function beobachten() {
    var ziele = doc.querySelectorAll ? doc.querySelectorAll(SICHTBAR) : [];
    if (!ziele.length) return;
    /* Ohne Beobachter (alte Browser) zählt die Anwesenheit — lieber eine etwas
     * zu hohe Bezugsgröße als gar keine. */
    if (typeof root.IntersectionObserver !== 'function') {
      for (var i = 0; i < ziele.length; i++) sichtMelden(ziele[i]);
      return;
    }
    var beobachter = new root.IntersectionObserver(function (eintraege) {
      for (var j = 0; j < eintraege.length; j++) {
        var e = eintraege[j];
        if (!e.isIntersecting || e.intersectionRatio < SICHT_ANTEIL) continue;
        beobachter.unobserve(e.target);
        sichtMelden(e.target);
      }
    }, { threshold: [SICHT_ANTEIL] });
    for (var k = 0; k < ziele.length; k++) beobachter.observe(ziele[k]);
  }

  // --------------------------------------------------------------- Geklickt

  function klick(e) {
    /* Mitteltaste kommt als auxclick; alle anderen Tasten öffnen nichts. */
    if (e.type === 'auxclick' && e.button !== 1) return;
    var ziel = e.target && typeof e.target.closest === 'function' ? e.target.closest('a[href]') : null;
    if (!zumBerater(ziel)) return;
    var wo = flaeche(ziel);
    if (wo) emit('geklickt', wo, aufgabe(ziel));
  }

  function start() {
    if (!doc || istBeraterseite()) return;
    /* Gleich laden, nicht erst beim Klick: Danach folgt sofort der
     * Seitenwechsel, für ein Nachladen bliebe keine Zeit. */
    ladeBruecke();
    /* Einfangphase: Ein Theme-Skript, das den Klick unterwegs anhält, soll die
     * Messung nicht mitnehmen. */
    doc.addEventListener('click', klick, true);
    doc.addEventListener('auxclick', klick, true);
    beobachten();
  }

  return {
    start: start,
    /* Für Tests und für die Fehlersuche im Browser. */
    flaeche: flaeche,
    aufgabe: aufgabe,
    zumBerater: zumBerater,
    seitentyp: function () { return typ; },
    zustand: function () {
      return { gemeldet: Object.keys(gemeldet), wartend: warteschlange.length, laedt: brueckeLaedt };
    },
  };
});
